export default __webpack_public_path__ + "static/media/WebDevelopment.53be90e5.png";